import { ADRType, CLIENTPIDMAPType, GENDERType, keyTypeGuard, NonEmptyStringArrayType, NType, NumberType, StringType, } from './runtimeTypes.js';
// VCard4 parameters with runtime introspection capability
export var knownParameters = {
    LANGUAGE: StringType,
    VALUE: StringType,
    PREF: NumberType,
    ALTID: StringType,
    PID: NonEmptyStringArrayType,
    TYPE: NonEmptyStringArrayType,
    MEDIATYPE: StringType,
    CALSCALE: StringType,
    SORT_AS: NonEmptyStringArrayType,
    GEO: StringType,
    TZ: StringType,
    LABEL: StringType,
    CC: StringType,
    INDEX: NumberType,
    LEVEL: StringType, // RFC6715
};
export var isKnownParameter = keyTypeGuard(knownParameters);
// VCard4 properties with runtime introspection capability
export var knownProperties = {
    // Cardinality: 1
    BEGIN: StringType,
    VERSION: StringType,
    END: StringType,
    // Cardinality: 1*
    FN: StringType,
    // Cardinality: *1
    PRODID: StringType,
    UID: StringType,
    REV: StringType,
    KIND: StringType,
    N: NType,
    BDAY: StringType,
    ANNIVERSARY: StringType,
    GENDER: GENDERType,
    BIRTHPLACE: StringType,
    DEATHPLACE: StringType,
    DEATHDATE: StringType,
    // Cardinality: *
    CLIENTPIDMAP: CLIENTPIDMAPType,
    SOURCE: StringType,
    XML: StringType,
    NICKNAME: NonEmptyStringArrayType,
    PHOTO: StringType,
    ADR: ADRType,
    TEL: StringType,
    EMAIL: StringType,
    IMPP: StringType,
    LANG: StringType,
    TZ: StringType,
    GEO: StringType,
    TITLE: StringType,
    ROLE: StringType,
    LOGO: StringType,
    ORG: NonEmptyStringArrayType,
    MEMBER: StringType,
    RELATED: StringType,
    CATEGORIES: NonEmptyStringArrayType,
    NOTE: StringType,
    SOUND: StringType,
    URL: StringType,
    KEY: StringType,
    FBURL: StringType,
    CALADRURI: StringType,
    CALURI: StringType,
    CONTACT_URI: StringType,
    EXPERTISE: StringType,
    HOBBY: StringType,
    INTEREST: StringType,
    ORG_DIRECTORY: StringType, // RFC6715
};
export var isKnownProperty = keyTypeGuard(knownProperties);
// "1" cardinality properties from RFC 6350
// Values are what is expected
export var exactlyOnceProperties = {
    BEGIN: 'VCARD',
    VERSION: '4.0',
    END: 'VCARD',
};
export var isExactlyOnceProperty = keyTypeGuard(exactlyOnceProperties);
// "1*" cardinality properties from RFC 6350
// Value is default
export var atLeastOnceProperties = { FN: '' };
export var isAtLeastOnceProperty = keyTypeGuard(atLeastOnceProperties);
// "*1" cardinality properties from RFC 6350
export var atMostOnceProperties = {
    PRODID: 0,
    UID: 0,
    KIND: 0,
    N: 0,
    BDAY: 0,
    ANNIVERSARY: 0,
    GENDER: 0,
    REV: 0,
    BIRTHPLACE: 0,
    DEATHPLACE: 0,
    DEATHDATE: 0,
};
export var isAtMostOnceProperty = keyTypeGuard(atMostOnceProperties);
//# sourceMappingURL=vcard4Types.js.map